import React, { useState, useEffect } from "react";
import { useHistory, useRouteMatch } from 'react-router-dom';
import { Auth } from 'aws-amplify';

import Config from './Config';

import { FetchConfig, GetUrl, UpdateConfig } from "./helpers/ConfigApi";
import { useInterval } from "./hooks/useInterval";

import { makeStyles, MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';

import Routes from "./Routes";
import Banner from './components/layout/Banner';
import Sponsors from './components/layout/Sponsors';
import Footer from './components/layout/Footer';
import Loading from "./containers/Loading";

const useStyles = makeStyles(theme => ({
  background: {
    backgroundColor: '#f2f2f2',
    backgroundSize: 'cover',
    backgroundPosition: 'top center',
    backgroundRepeat: 'no-repeat',
  },
  container: {
    minHeight: '600px'
  }
}));

const App = () => {
  const [user, setUser] = useState();
  const [isInitialising, setIsInitialising] = useState(true);
  const [isAuthenticated, userHasAuthenticated] = useState(false);
  const [message, setMessage] = useState({ type: 'info', description: "Loading ... " });
  const [config, setConfig] = useState();
  const [url, setUrl] = useState(GetUrl(Config.URL_CONFIG));
  const history = useHistory();

  useEffect(() => {
    // refresh token
    Auth.currentSession()
      .then(data => console.log(data))
      .catch(err => console.log(err));

    // look for logged in user
    Auth.currentAuthenticatedUser()
      .then(user => {
        console.log(user);
        setUser(user);
        userHasAuthenticated(true);
      })
      .catch(err => console.log(err));
  }, []);

  useEffect(() => {
    if (url) {
      FetchConfig(url).then((newConfig) => {
        if (newConfig) {
          // console.log('newConfig', newConfig)
          const updatedConfig = UpdateConfig(newConfig);
          // console.log('updatedConfig', updatedConfig)
          setConfig(updatedConfig);
          setIsInitialising(false);
        }
      }).catch(e => { console.log(e); setMessage({ type: 'error', description: e.message }); });
    }
  }, [url]);

  useInterval(() => {
    setUrl(GetUrl(Config.URL_CONFIG));
  }, 60000);

  const Logout = () => {
    Auth.signOut().then(() => {
      userHasAuthenticated(false);
      setUser();
      history.push('/login');
    })
      .catch(e => console.log(e.message));
  };

  const theme = createMuiTheme({
    palette: {
      primary: {
        main: '#0f235e',
        contrastText: "#fff"

      },
      secondary: {
        main: '#000',
        contrastText: "#fff"
      }
    },
    typography: {
      fontFamily: [
        'Roboto',
        '"Helvetica Neue"',
        'Arial',
        'sans-serif'
      ].join(','),
    },
    headings: {
      fontFamily: [
        '"Bebas Neue"',
        'Roboto',
        '"Helvetica Neue"',
        'Arial',
        'sans-serif'
      ].join(','),
    }
  },
  );

  let backgroundStyle = {};
  const match = useRouteMatch({ path: '/:page?', exact: false });
  if (match) {
    switch (match.params.page) {
      case undefined:
      case "home":
        backgroundStyle.backgroundImage = `url("https://events-public-assets.s3-ap-southeast-2.amazonaws.com/events/channelasia/images/background.jpg")`;
        backgroundStyle.backgroundColor = `#0f235e`;
        break;

      case "player":
        backgroundStyle.backgroundImage = `url("https://events-public-assets.s3-ap-southeast-2.amazonaws.com/events/channelasia/images/gradient.lrg.jpg")`;
        backgroundStyle.backgroundColor = `#364d92`;
        break;

      case "login":
      case "register":
      case "reset":
      case "activate":
        backgroundStyle.backgroundImage = `url("https://events-public-assets.s3-ap-southeast-2.amazonaws.com/events/channelasia/images/gradient.sml.jpg")`;
        backgroundStyle.backgroundColor = `#364d92`;
        break;

      case "event":
        backgroundStyle.backgroundImage = `none`;
        backgroundStyle.backgroundColor = `#0f235e`;
        break;
  
      default: break;
    }
  }

  const classes = useStyles();
  return (
    <MuiThemeProvider theme={theme}>
      <CssBaseline />
      <div className="App">
        {isInitialising && (
          <Loading message={message} />
        )}
        {!isInitialising && (
          <>
            <div className={classes.background} style={backgroundStyle}>
              <Banner config={config.banner} isAuthenticated={isAuthenticated} Logout={Logout} />
              <div className={classes.container}>
                <Routes appProps={{ isAuthenticated, userHasAuthenticated, setUser, user, config }} />
              </div>
            </div>
            <Sponsors config={config.sponsors} />
            <Footer config={config.footer} />
          </>
        )}

      </div>
    </MuiThemeProvider>
  );
};

export default App;